/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_F4Inputs */

const en_wc_tut_keys_f4 = /** @type {(inputs: Wc_Tut_Keys_F4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeat the last action`)
};

/**
* | output |
* | --- |
* | "Repeat the last action" |
*
* @param {Wc_Tut_Keys_F4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_f4 = /** @type {((inputs?: Wc_Tut_Keys_F4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_F4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_f4(inputs)
});
export { wc_tut_keys_f4 as "wc.tut.keys.f4" }